import { Factory } from '../../services/Factory';

export interface ITooltipScope extends angular.IScope {
}

export interface ITooltipAttributes extends angular.IAttributes {
iioTooltip: string;
iioTooltipPlacement: string;
}

export class TooltipPlacement implements angular.IDirective {
public controller: () => void;

constructor() {
this.controller = () => {
};
}
}

export class Tooltip implements angular.IDirective {
public restrict = 'A';
public link: (scope: ITooltipScope, element: angular.IAugmentedJQuery, attrs: ITooltipAttributes) => void;
public require = ["ngModel", "iioTooltipPlacement"];
public replace = false;

constructor() {
this.link = (scope: ITooltipScope, element: angular.IAugmentedJQuery, attrs: ITooltipAttributes) => {
  if (element.parent().hasClass("btn-group")) {
    element.on("mouseover", () => {
      $("<div class='toolbarContainer' />").insertBefore(element.parent());
      (element as any).tooltip({
        container: '.toolbarContainer',
        trigger: 'manual',
        placement: attrs.iioTooltipPlacement,
        title: attrs.iioTooltip
      }).tooltip("show");
    });

    element.on("mouseout", () => {
      (element as any).tooltip("hide");

      element.parent().prev().remove();
    });
  } else {
    (element as any).tooltip({
      placement: attrs.iioTooltipPlacement,
      title: attrs.iioTooltip
    });
  }
}
}
}

frontendApp.directive("iioTooltip", [Factory.Create(Tooltip)]);
frontendApp.directive("iioTooltipPlacement", [Factory.Create(TooltipPlacement)]);
